// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NNyH","label":"styles_label__1KDyW"};